import { ModalActionTypes } from "./modal.types";

const INITIAL_STATE = {
  hidden: true,
};

const ModalReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case ModalActionTypes.TOGGLE_MODAL_HIDDEN:
      return {
        ...state,
        hidden: !state.hidden,
      };
    default:
      return state;
  }
};

export default ModalReducer;
